import React from "react";

export default function EmptyState({ icon: Icon, title, hint, testid }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center rounded-sm border border-dashed border-zinc-800 bg-zinc-950/40 px-6 py-10 text-center">
      {Icon && (
        <span className="mb-3 flex h-11 w-11 items-center justify-center rounded-sm bg-zinc-900 text-zinc-600">
          <Icon size={22} weight="bold" />
        </span>
      )}
      <p className="text-sm font-semibold text-zinc-300">{title}</p>
      {hint && <p className="mt-1 max-w-xs text-xs text-zinc-500">{hint}</p>}
    </div>
  );
}
